import { render, staticRenderFns } from "./CouponField.vue?vue&type=template&id=74b22740&scoped=true&"
import script from "./CouponField.vue?vue&type=script&lang=js&"
export * from "./CouponField.vue?vue&type=script&lang=js&"
import style0 from "./CouponField.vue?vue&type=style&index=0&id=74b22740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b22740",
  null
  
)

export default component.exports